"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const detect_utils_1 = require("@/common/detect_utils");
const DeliverySettingAddress_1 = require("@/common/components/DeliverySetting/DeliverySettingAddress");
const errors_1 = require("@/common/errors");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
function default_1({ userId, managingAddressId, isManageAddressInProgress, setIsManageAddressInProgress, manageAddressForm, hasNoAddress, isEditMode, disableInputMode, fetchAddressList, }) {
    const { handleSubmit, setError, formState: { dirtyFields }, } = manageAddressForm;
    const [isUpdating, setIsUpdating] = (0, react_1.useState)(false);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const updateAddress = (inputData) => __awaiter(this, void 0, void 0, function* () {
        const hasAddress = Boolean(inputData.address);
        if (!hasAddress) {
            setError('root.noAddress', {
                type: 'required',
                message: t('"주소 찾기" 또는 "직접 주소 입력" 버튼을 눌러 주소를 입력해주세요!'),
            });
        }
        else if (!isManageAddressInProgress) {
            const data = {};
            const dataKeyArr = isEditMode ? Object.keys(dirtyFields) : Object.keys(inputData);
            dataKeyArr.forEach(keys => Object.assign(data, { [keys]: inputData[keys] }));
            if (hasNoAddress)
                data.is_default = true;
            !data.en_address && delete data.en_address;
            !data.en_address_detail && delete data.en_address_detail;
            if ((0, detect_utils_1.isEmptyObject)(data))
                disableInputMode();
            else {
                setIsManageAddressInProgress(true);
                setIsUpdating(true);
                const updateData = isEditMode ? api_1.patchData : api_1.postData;
                const updateUrl = `/api/v1/members/${userId}/deliveries${isEditMode ? `/${managingAddressId}` : ''}`;
                const refetchAddressOnUpdate = () => __awaiter(this, void 0, void 0, function* () {
                    yield fetchAddressList();
                    disableInputMode();
                    setIsManageAddressInProgress(false);
                });
                yield updateData(updateUrl, data)
                    .then(() => __awaiter(this, void 0, void 0, function* () {
                    yield refetchAddressOnUpdate();
                }))
                    .catch(err => {
                    var _a, _b, _c, _d;
                    const errorStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
                    const errorCode = (_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
                    if (errorStatus === 400 || errorStatus === 404) {
                        (0, DeliverySettingAddress_1.handleManageAddressErrors)({
                            confirm,
                            errorCode,
                            concurrenceFn: refetchAddressOnUpdate,
                        });
                    }
                    else if (errorStatus === 403)
                        (0, errors_1.handle403Error)(err);
                    else
                        (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
                    setIsManageAddressInProgress(false);
                    setIsUpdating(false);
                });
            }
        }
    });
    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ disabled: isManageAddressInProgress, onClick: handleSubmit(updateAddress), sx: {
            width: '100%',
            height: '56px',
            p: '0px 8px',
            borderRadius: '12px',
            bgcolor: 'var(--primary-main) !important',
            color: 'var(--white) !important',
            fontSize: '18px',
            fontWeight: 'bold',
        } }, { children: isUpdating ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "inherit", thickness: 8 })) : ((0, jsx_runtime_1.jsx)("span", { children: t('저장') })) })));
}
exports.default = default_1;
